import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './AboutSettings.css';

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

const emptyAbout = {
  eyebrow: '',
  heading: '',
  body: '',
  subtitle: '',
  eyebrowFontSize: 13,
  headingFontSize: 38,
  bodyFontSize: 16,
  subtitleFontSize: 13,
};

function AboutSettings() {
  const [about, setAbout] = useState(emptyAbout);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const fetchAbout = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/about-section`);
        setAbout({ ...emptyAbout, ...response.data });
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAbout();
  }, []);

  const handleChange = (field, value) => {
    setAbout((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    setIsSaving(true);
    setMessage('');

    try {
      await axios.put(`${API_BASE_URL}/api/about-section`, about);
      setMessage('About section updated successfully.');
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
      setMessage('Unable to save About section. Please try again.');
    } finally {
      setIsSaving(false);
    }
  };

  if (isLoading) {
    return <p className="about-settings-loading">Loading About content…</p>;
  }

  return (
    <div className="about-settings">
      <div className="about-settings-header">
        <div>
          <h2 className="about-settings-title">About section</h2>
          <p className="about-settings-subtitle">
            Control the text and typography of the home-page About card. The
            image stays fixed.
          </p>
        </div>
        <button
          type="button"
          className="about-settings-save-btn"
          onClick={handleSave}
          disabled={isSaving}
        >
          {isSaving ? 'Saving…' : 'Save changes'}
        </button>
      </div>

      <div className="about-settings-grid">
        <div className="about-settings-field">
          <label className="about-settings-label">
            Eyebrow label
            <input
              type="text"
              className="about-settings-input"
              value={about.eyebrow}
              onChange={(e) => handleChange('eyebrow', e.target.value)}
              placeholder="WHALES ADVISOR"
            />
          </label>
        </div>

        <div className="about-settings-field">
          <label className="about-settings-label">
            Heading
            <input
              type="text"
              className="about-settings-input"
              value={about.heading}
              onChange={(e) => handleChange('heading', e.target.value)}
              placeholder="About Us"
            />
          </label>
        </div>

        <div className="about-settings-field about-settings-field-wide">
          <label className="about-settings-label">
            Main body text
            <textarea
              className="about-settings-textarea"
              rows={4}
              value={about.body}
              onChange={(e) => handleChange('body', e.target.value)}
              placeholder="Main paragraph describing Whales Advisory."
            />
          </label>
        </div>

        <div className="about-settings-field about-settings-field-wide">
          <label className="about-settings-label">
            Subtitle
            <input
              type="text"
              className="about-settings-input"
              value={about.subtitle}
              onChange={(e) => handleChange('subtitle', e.target.value)}
              placeholder="We deliver end‑to‑end solutions from idea to production."
            />
          </label>
        </div>

        <div className="about-settings-field">
          <label className="about-settings-label">
            Eyebrow font size (px)
            <input
              type="number"
              className="about-settings-input"
              min={10}
              max={32}
              value={about.eyebrowFontSize}
              onChange={(e) =>
                handleChange('eyebrowFontSize', Number(e.target.value) || 0)
              }
            />
          </label>
        </div>

        <div className="about-settings-field">
          <label className="about-settings-label">
            Heading font size (px)
            <input
              type="number"
              className="about-settings-input"
              min={20}
              max={64}
              value={about.headingFontSize}
              onChange={(e) =>
                handleChange('headingFontSize', Number(e.target.value) || 0)
              }
            />
          </label>
        </div>

        <div className="about-settings-field">
          <label className="about-settings-label">
            Body font size (px)
            <input
              type="number"
              className="about-settings-input"
              min={12}
              max={24}
              value={about.bodyFontSize}
              onChange={(e) =>
                handleChange('bodyFontSize', Number(e.target.value) || 0)
              }
            />
          </label>
        </div>

        <div className="about-settings-field">
          <label className="about-settings-label">
            Subtitle font size (px)
            <input
              type="number"
              className="about-settings-input"
              min={10}
              max={24}
              value={about.subtitleFontSize}
              onChange={(e) =>
                handleChange('subtitleFontSize', Number(e.target.value) || 0)
              }
            />
          </label>
        </div>
      </div>

      {message && <p className="about-settings-message">{message}</p>}
    </div>
  );
}

export default AboutSettings;

